function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import scroller from '4finance-scroller';
/**
* Used in ScrollingForm to automatically scroll to validation errors on submit
* @param {Object} options - for 4finance-scroller, e.g. 'duration'
* @return {null} nothing is returned as function is producing side effect
*/

export default function scrollToError() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  scroller.scrollTo('errorMessage', _objectSpread({
    duration: 1000,
    offset: -100,
    smooth: true
  }, options));
}